import { useContext } from "react";
import { CallListGlobalModalContext } from "./call-list-global-modal-context";

export function useCallListGlobalModalContext() {
  const ctx = useContext(CallListGlobalModalContext);

  if (!ctx) {
    throw new Error(
      "useCallListGlobalModalContext must be used within a CallListGlobalModalContextProvider"
    );
  }

  return ctx;
}
